import Flexbox from './flexbox'
import FlexboxItem from './flexbox-item'

export {
  Flexbox,
  FlexboxItem
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/flexbox/index.js